<div #zoomCurrentLocationContainer>
    <button #zoomCurrentLocationBtn class="current-location" type="button" 
        aria-expanded="false" aria-controls="current-location" title="Zoom to current location"
        (click)="onZoomToClicked($event)" aria-label="Current location">
        <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true" 
            alt="Current location">near_me</span>
        <span class="sr-only">Current location</span>							
    </button>    
</div>

